<template>
  <div class="page-login-form register">
    <v-form
      role="form"
      class="login-form"
      method="POST"
      action="#"
      v-on:keyup="submitFormListenerOnEntryKey"
    >
      <v-alert
        outlined
        type="error"
        prominent
        border="left"
        v-if="formErrors.length > 0"
      >
        <b>Veuillez corriger les erreurs suivantes:</b>
        <ul>
          <li v-for="(error, index) in formErrors" :key="index">
            • {{ error }}
          </li>
        </ul>
      </v-alert>
      <div class="form-group is-empty">
        <div class="row">
          <label class="col-md-3 col-md-offset-1 col-sm-12"
            ><h4>Je suis un</h4></label
          >
          <div class="col-md-4 col-sm-12">
            <label for="seeker" style="padding-right: 1em">Candidat</label>
            <input
              id="seeker"
              type="radio"
              name="userType"
              value="seeker"
              v-model="userType"
              required
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label for="company" style="padding-right: 1em">Employeur</label>
            <input
              required
              id="company"
              type="radio"
              name="userType"
              value="company"
              v-model="userType"
            />
          </div>
        </div>
        <span class="material-input"></span>
      </div>

      <div class="form-group is-empty" v-if="userType === 'company'">
        <div class="input-icon">
          <i class="ti-home"></i>
          <input
            type="text"
            id="companyName"
            class="form-control"
            name="companyName"
            v-model="companyName"
            :required="userType === 'company'"
            placeholder="Nom de l'entreprise"
          />
        </div>
        <span class="material-input"></span>
      </div>

      <div class="row" v-if="userType === 'company'">
        <div class="col-12">
          <v-autocomplete
            label="Secteur d'activité"
            id="companyActivitySector"
            name="companyActivitySector"
            class="form-control col-12 col-md-12 col-sm-12"
            v-model="companyActivitySector"
            :required="userType === 'company'"
            item-text="name"
            item-value="id"
            :items="activitySectorItems"
            solo
          ></v-autocomplete>
        </div>
      </div>
      <div class="form-group"></div>

      <div class="form-group is-empty">
        <div class="input-icon">
          <i class="ti-user"></i>
          <input
            type="text"
            id="lastname"
            class="form-control"
            name="lastname"
            v-model="lastname"
            required
            placeholder="Nom"
          />
        </div>
        <span class="material-input"></span>
      </div>

      <div class="form-group is-empty">
        <div class="input-icon">
          <i class="ti-user"></i>
          <input
            type="text"
            id="firstname"
            class="form-control"
            name="firstname"
            v-model="firstname"
            required
            placeholder="Prénoms"
          />
        </div>
        <span class="material-input"></span>
      </div>

      <div class="form-group is-empty">
        <div class="input-icon">
          <i class="ti-email"></i>
          <input
            type="email"
            id="email"
            class="form-control"
            name="email"
            placeholder="Email"
            v-model="email"
            required
          />
        </div>
        <span class="material-input"></span>
      </div>
      <div class="form-group is-empty">
        <div class="input-icon">
          <i class="ti-lock"></i>
          <input
            name="password"
            v-model="password"
            type="password"
            class="form-control"
            placeholder="Mot de passe"
            required
          />
        </div>
        <span class="material-input"></span>
      </div>
      <div class="form-group is-empty">
        <div class="input-icon">
          <i class="ti-lock"></i>
          <input
            type="password"
            name="repeatPassword"
            v-model="repeatPassword"
            class="form-control"
            placeholder="Répéter le mot de passe"
            required
          />
        </div>
        <span class="material-input"></span>
      </div>
      <button
        type="button"
        class="btn btn-common log-btn"
        v-on:click="registerUser"
      >
        Inscription
      </button>
    </v-form>
  </div>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";

export default {
  name: "Register",
  data: function () {
    return {
      activitySectorItems: [],
      formErrors: [],
      userType: null,
      firstname: null,
      lastname: null,
      email: null,
      password: null,
      repeatPassword: null,
      companyName: null,
      activitySectorList: [],
      companyActivitySector: null,
      afterRegistration: "",
    };
  },
  props: {
    nextUrl: String,
  },
  created() {
    this.afterRegistration =
      "/my-account?registration=true&nextUrl=" + this.nextUrl;
    console.log("this.afterRegistration");
    console.log(this.afterRegistration);
    const httpClient = new HttpClient();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    httpClient
      .getActivitiesSector()
      .then((value) => {
        self.activitySectorList = value.data;
        value.data.forEach((elt) => {
          this.activitySectorItems.push({
            id: elt.id,
            name: elt.name,
          });
        });
      })
      .catch((reason) => {
        self.formErrors.push(reason);
        console.error(reason);
      });
  },

  methods: {
    checkForm: function (e) {
      let isValid = true;
      this.formErrors = [];
      if (this.userType !== "company" && this.userType !== "seeker") {
        isValid = false;
        this.formErrors.push("Le type d'utilisateur est invalide.");
      }

      if (this.userType === "company") {
        if (!this.companyName || this.companyName.trim() === "") {
          isValid = false;
          this.formErrors.push(
            "Le nom de l'entreprise est requis pour les utilisateurs « employeur »."
          );
        }

        if (!this.companyActivitySector) {
          isValid = false;
          this.formErrors.push(
            "Le secteur d'activité de l'entreprise est obligatoire pour les utilisateurs « employeur »."
          );
        }
      }

      if (!this.firstname || this.firstname.trim() === "") {
        isValid = false;
        this.formErrors.push("Le prénom est obligatoire.");
      }

      if (!this.lastname || this.lastname.trim() === "") {
        isValid = false;
        this.formErrors.push("Le nom est obligatoire.");
      }

      if (!this.email || this.email.trim() === "") {
        isValid = false;
        this.formErrors.push("L'email est obligatoire.");
      } else if (!this.validateEmail(this.email)) {
        isValid = false;
        this.formErrors.push("L'email est invalide.");
      }

      if (!this.password || this.password.trim() === "") {
        isValid = false;
        this.formErrors.push("Le mot de passe est obligatoire.");
      }

      if (!this.repeatPassword || this.repeatPassword.trim() === "") {
        isValid = false;
        this.formErrors.push("Ressaisir le mot de passe est obligatoire.");
      }

      if (this.repeatPassword !== this.password) {
        isValid = false;
        this.formErrors.push("Les mots de passes ne sont pas identiques ");
      }

      return isValid;
    },

    validateEmail: function (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    registerUser: function (e) {
      if (this.checkForm()) {
        e.preventDefault();
        const httpClient = new HttpClient();
        httpClient
          .registerUser({
            firstname: this.firstname,
            lastname: this.lastname,
            username: this.email,
            email: this.email,
            password: this.password,
            type: this.userType,
            companyName: this.companyName,
            companySector: this.companyActivitySector,
          })
          .then(() => {
            window.location.href = this.afterRegistration;
          })
          .catch((reason) => {
            this.formErrors = [];
            if (reason.response.status === 400) {
              this.formErrors.push(
                "Les informations saisies sont incorrectes. Un compte utilisateur existe déjà avec les mêmes informations."
              );
            } else {
              this.formErrors.push(reason.response.statusText);
            }
          });
      }
    },

    submitFormListenerOnEntryKey: function (event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        this.registerUser();
      }
    },
  },
};
</script>

<style scoped></style>
